<template>
  <modal
    name="desconto-form"
    height="auto"
    width="92%"
    :max-width="1100"
    :adaptive="true"
    :scrollable="true"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <h5 class="form-title">{{ isEdit ? 'Editar desconto' : 'Novo desconto' }}</h5>

        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Regras">
            <div class="row">
              <div class="col-md-2">
                <label class="form-label">Cód <span class="req">*</span></label>
                <input type="text" class="form-control" v-model="form.id" :disabled="isEdit" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Ativo</label>
                <select class="form-control" v-model.number="form.ativo">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Exibe Call?</label>
                <select class="form-control" v-model.number="form.aplicacallcenter">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Exibe B2B?</label>
                <select class="form-control" v-model.number="form.aplicab2b">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Exibe FV?</label>
                <select class="form-control" v-model.number="form.aplicafv">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Apli. Automático?</label>
                <select class="form-control" v-model.number="form.aplicaautomatico">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-12">
                <label class="form-label">Descrição</label>
                <input type="text" class="form-control" v-model="form.descricao" />
              </div>
            </div>

            <h6 class="section-label">Parâmetros de aplicação</h6>
            <div class="row">
              <div class="col-md-2">
                <label class="form-label">% Desc. <span class="req">*</span></label>
                <input-percent class="form-control" v-model="form.percdesconto" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Perc. Máx Desc</label>
                <input-percent class="form-control" v-model="form.percmaximodesc" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Qtd. Mín <span class="req">*</span></label>
                <input type="number" class="form-control" v-model.number="form.qtdmin" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Qtd. Máx</label>
                <input type="number" class="form-control" v-model.number="form.qtdmax" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Dt. início <span class="req">*</span></label>
                <InputDatePicker v-model="form.dtinicio" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Dt. fim <span class="req">*</span></label>
                <InputDatePicker v-model="form.dtfim" />
              </div>

              <div class="col-md-2">
                <label class="form-label">Cód. Política</label>
                <input type="text" class="form-control" v-model="form.politica_id" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Prioritária?</label>
                <select class="form-control" v-model.number="form.prioritaria">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Pri. Geral?</label>
                <select class="form-control" v-model.number="form.prioritariageral">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Somente retira?</label>
                <select class="form-control" v-model.number="form.somenteretira">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Cód. Plano</label>
                <input type="text" class="form-control" v-model="form.planopagamento_id" />
              </div>
              <div class="col-md-2">
                <label class="form-label">Múltiplo</label>
                <input type="number" class="form-control" v-model.number="form.multiplo" />
              </div>
            </div>

            <h6 class="section-label">Exibição e preço</h6>
            <div class="row">
              <div class="col-md-3">
                <label class="form-label">Visível ao cliente?</label>
                <select class="form-control" v-model.number="form.visivel">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Exibe flag?</label>
                <select class="form-control" v-model.number="form.exibeflag">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Altera Preço Tabela?</label>
                <select class="form-control" v-model.number="form.alteraprecotabela">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Tabela de Preço</label>
                <input type="text" class="form-control" v-model="form.tabelapreco" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Num. Col. preço</label>
                <select class="form-control" v-model="form.coluna_preco">
                  <option :value="null">Todas</option>
                  <option v-for="n in 7" :key="n" :value="String(n)">Preço {{ n }}</option>
                </select>
              </div>
            </div>
          </CTab>

          <CTab title="Conta corrente">
            <div class="row">
              <div class="col-md-6">
                <label class="form-label">Credita CC ao RCA se não conceder o desconto total?</label>
                <select class="form-control" v-model.number="form.creditacontacorrente">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Debita CC do RCA se conceder o desconto?</label>
                <select class="form-control" v-model.number="form.politicacontacorrente">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
            </div>
          </CTab>

          <CTab title="Restrições · Cliente">
            <div class="row">
              <div class="col-md-3">
                <label class="form-label">Cód. Filial</label>
                <input type="text" class="form-control" v-model="form.filial_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. Região</label>
                <input type="text" class="form-control" v-model="form.regiao_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. Praça</label>
                <input type="text" class="form-control" v-model="form.praca_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. Rede</label>
                <input type="text" class="form-control" v-model="form.rede_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. Atividade</label>
                <input type="text" class="form-control" v-model="form.atividade_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. Cliente</label>
                <input type="text" class="form-control" v-model="form.cliente_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. Superv.</label>
                <input type="text" class="form-control" v-model="form.supervisor_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. RCA</label>
                <input type="text" class="form-control" v-model="form.representante_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Cód. Operador</label>
                <input type="text" class="form-control" v-model="form.operador_id" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Valida Cód. RCA?</label>
                <select class="form-control" v-model.number="form.validausuario">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
            </div>
          </CTab>

          <CTab title="Restrições · Produto">
            <div class="row">
              <div class="col-md-4">
                <label class="form-label">Cód. Produto</label>
                <input type="text" class="form-control" v-model="form.produto_id" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Cód. Prod. Principal</label>
                <input type="text" class="form-control" v-model="form.produtoprincipal_id" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Cód. Fornecedor</label>
                <input type="text" class="form-control" v-model="form.fornecedor_id" />
              </div>
            </div>
            <h6 class="section-label">Dimensões</h6>
            <div class="row">
              <div class="col-md-3" v-for="n in 10" :key="`dim-${n}`">
                <label class="form-label">Cód. Dim. {{ n }}</label>
                <input type="text" class="form-control" v-model="form[`dimensao${n}`]" />
              </div>
            </div>
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">Cancelar</CButton>
      <CButton color="primary" @click="submit" :disabled="saving">
        {{ saving ? 'Salvando...' : (isEdit ? 'Salvar alterações' : 'Cadastrar') }}
      </CButton>
    </div>
  </modal>
</template>

<script>
import CloseModal from "@/components/CloseModal";
import InputDatePicker from "@/components/InputDatePicker";
import { post, put } from "@/helpers/apiRequest";

const EMPTY = () => ({
  id: null,
  ativo: 1,
  aplicacallcenter: 1,
  aplicab2b: 1,
  aplicafv: 1,
  aplicaautomatico: 0,
  descricao: '',
  percdesconto: '',
  percmaximodesc: '',
  qtdmin: 0,
  qtdmax: null,
  dtinicio: null,
  dtfim: null,
  politica_id: null,
  prioritaria: 0,
  prioritariageral: 0,
  somenteretira: 0,
  planopagamento_id: null,
  multiplo: null,
  visivel: 1,
  exibeflag: 1,
  alteraprecotabela: 0,
  tabelapreco: null,
  coluna_preco: null,
  creditacontacorrente: 0,
  politicacontacorrente: 0,
  filial_id: null,
  regiao_id: null,
  praca_id: null,
  rede_id: null,
  atividade_id: null,
  cliente_id: null,
  supervisor_id: null,
  representante_id: null,
  operador_id: null,
  validausuario: 0,
  produto_id: null,
  produtoprincipal_id: null,
  fornecedor_id: null,
  dimensao1: null,
  dimensao2: null,
  dimensao3: null,
  dimensao4: null,
  dimensao5: null,
  dimensao6: null,
  dimensao7: null,
  dimensao8: null,
  dimensao9: null,
  dimensao10: null,
});

export default {
  name: "DescontoFormModal",
  components: { CloseModal, InputDatePicker },
  props: {
    editing: { type: Object, default: null },
  },
  data() {
    return {
      form: EMPTY(),
      saving: false,
    };
  },
  computed: {
    isEdit() {
      return !!this.editing && !!this.editing.id;
    },
  },
  watch: {
    editing: {
      immediate: true,
      handler(value) {
        const base = value ? { ...EMPTY(), ...value } : EMPTY();
        if (base.percdesconto === null || base.percdesconto === undefined) base.percdesconto = '';
        if (base.percmaximodesc === null || base.percmaximodesc === undefined) base.percmaximodesc = '';
        this.form = base;
      },
    },
  },
  methods: {
    close() {
      this.$modal.hide('desconto-form');
    },
    payload() {
      const item = { ...this.form };
      if (item.percdesconto === '') item.percdesconto = null;
      if (item.percmaximodesc === '' || item.percmaximodesc === 0) item.percmaximodesc = null;
      return item;
    },
    validate() {
      const missing = [];
      if (!this.form.id && this.form.id !== 0) missing.push('Cód');
      if (this.form.percdesconto === '' || this.form.percdesconto === null || this.form.percdesconto === undefined) missing.push('% Desc.');
      if (this.form.qtdmin === '' || this.form.qtdmin === null || this.form.qtdmin === undefined) missing.push('Qtd. Mín');
      if (!this.form.dtinicio) missing.push('Dt. início');
      if (!this.form.dtfim) missing.push('Dt. fim');
      return missing;
    },
    submit() {
      if (this.saving) return;
      const missing = this.validate();
      if (missing.length) {
        new window.swal({
          title: 'Campos obrigatórios não preenchidos',
          text: missing.join(', '),
          icon: 'warning',
        });
        return;
      }
      const item = this.payload();
      this.saving = true;

      const onSuccess = (json) => {
        this.saving = false;
        new window.swal({
          title: json && json.message ? json.message : 'Salvo com sucesso',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        });
        this.$emit('saved');
        this.close();
      };
      const onError = (err) => {
        this.saving = false;
        new window.swal({
          title: 'Falha ao salvar',
          text: err && err.message ? err.message : 'Erro inesperado',
          icon: 'error',
        });
      };

      const request = this.isEdit
        ? put(`/admin/descontos/${item.id}`, item)
        : post('/admin/descontos', item);
      request.then(onSuccess).catch(onError);
    },
  },
};
</script>

<style scoped>
.form-title {
  font-weight: 600;
  margin-bottom: 16px;
}

.section-label {
  font-size: 13px;
  font-weight: 600;
  color: #3a3e81;
  margin: 18px 0 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eee;
}

.form-label {
  font-size: 12px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 4px;
  display: block;
}

.req {
  color: #e5484d;
}

.row {
  row-gap: 12px;
}

.row > [class^="col-"] {
  margin-bottom: 4px;
}

.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
